module.exports = __webpack_public_path__ + "img/portraits_11_V.ff1460fb.jpg";